export const actionTypes = {
  GET_STATUS: 'MESSAGES.OLD_VERSION_NOTIFICATION.GET_STATUS',
  GET_INFO_SKIP_LOADING: 'MESSAGES.OLD_VERSION_NOTIFICATION.GET_INFO.SKIP_LOADING',
  REQUEST_SUCCESS: 'MESSAGES.OLD_VERSION_NOTIFICATION.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'MESSAGES.OLD_VERSION_NOTIFICATION.REQUEST_FAILURE',
  CLEAR_MESSAGES: 'MESSAGES.OLD_VERSION_NOTIFICATION.CLEAR_MESSAGES',
};

export function getLk20Status() {
  return {
    type: actionTypes.GET_STATUS,
  };
}

export function getOldVersionSkipLoading() {
  return {
    type: actionTypes.GET_INFO_SKIP_LOADING,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}

export function clearMessages() {
  return {
    type: actionTypes.CLEAR_MESSAGES,
  };
}
